import { createSelector } from 'reselect';

const substate = (state) => state.storefront;

export const selectUserInterface = () => createSelector(substate, (contextState) => contextState.userInterface);
